var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGettingStartedNetworkingBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 90C69.8528 90 90 69.8528 90 45C90 20.1471 69.8528 0 45 0C20.1471 0 0 20.1471 0 45C0 69.8528 20.1471 90 45 90Z",
    fill: "#DEF6FC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_63_842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8274 32.34L33.0149 42.9625M47.0324 56.985L57.6599 60.1725",
    stroke: "#0C6CDE",
    strokeWidth: 2.205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2074 45.7925L58.6049 31.395",
    stroke: "#0C6CDE",
    strokeWidth: 2.205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7501 32.5C30.8211 32.5 32.5001 30.8211 32.5001 28.75C32.5001 26.679 30.8211 25 28.7501 25C26.679 25 25.0001 26.679 25.0001 28.75C25.0001 30.8211 26.679 32.5 28.7501 32.5Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2499 32.5C63.3209 32.5 64.9999 30.8211 64.9999 28.75C64.9999 26.679 63.3209 25 61.2499 25C59.1788 25 57.4999 26.679 57.4999 28.75C57.4999 30.8211 59.1788 32.5 61.2499 32.5Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2499 65C63.3209 65 64.9999 63.3211 64.9999 61.25C64.9999 59.1789 63.3209 57.5 61.2499 57.5C59.1788 57.5 57.4999 59.1789 57.4999 61.25C57.4999 63.3211 59.1788 65 61.2499 65Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2501 65C42.4633 65 47.5001 59.9632 47.5001 53.75C47.5001 47.5368 42.4633 42.5 36.2501 42.5C30.0369 42.5 25.0001 47.5368 25.0001 53.75C25.0001 59.9632 30.0369 65 36.2501 65Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_63_842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGettingStartedNetworkingBlue);
export default __webpack_public_path__ + "static/media/Icon_GettingStarted_Networking_Blue.c9ce54f37f58cbf8d4113f66752f80d4.svg";
export { ForwardRef as ReactComponent };